import React, { useState, useEffect, createContext, useContext } from 'react';
import { IntlProvider } from 'react-intl';
import Cookies from 'universal-cookie';
import { Language, LanguageContextType } from './types';
import langs from './langs.json';
import EN from '../../translations/compiled/en.json';
import DE from '../../translations/compiled/de.json';
import TABLE_LOCALIZATION_DE from '../../translations/materialTable/de.json';

const cookies = new Cookies();
const defaultLanguage: Language = langs.en;

export const LanguageContext = createContext<LanguageContextType | null>(null);

export const useLanguageContext = (): LanguageContextType => useContext(LanguageContext) as LanguageContextType;

export const LanguageProvider: React.FC<React.ReactNode> = ({ children }) => {
	const cachedLanguage = cookies.get('language');

	const [language, setLanguage] = useState<Language>(cachedLanguage || defaultLanguage);
	const [tableLocalization, setMaterialTableLocalization] = useState<object | undefined>();

	useEffect(() => {
		setMaterialTableLocalization(language.key === 'de' ? TABLE_LOCALIZATION_DE : undefined);
	}, [language]);

	useEffect(() => {
		cookies.set('language', language, { path: '/' });
	}, [language]);

	return (
		<LanguageContext.Provider value={{ language, setLanguage, tableLocalization }}>
			<IntlProvider locale={language.key} messages={language.key === 'de' ? DE : EN}>
				{children}
			</IntlProvider>
		</LanguageContext.Provider>
	);
};

export default LanguageContext;
